import { useIsMobile } from '@/shared/hooks/use-is-mobile'
import { HomeDesktop } from './page.home.desktop'
import { HomeMobile } from './page.home.mobile'

// Mobile and desktop layouts differ completely, so only one tree is mounted.
export function HomePage() {
  const isMobile = useIsMobile()
  return isMobile ? <HomeMobile /> : <HomeDesktop />
}
